import React from 'react';
import Navbar from '../../components/navbar/Navbar'
import Header from '../../container/Header/Header'
import About from '../../container/About/About'
import Footer from '../../container/Footer/Footer'

function Welcome() {
  return (
    <>
    
      <Header/>
      <About />
      <Footer />
    </>
  )
}
export default Welcome;
